import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter.jsx';
import * as THREE from 'three';

const BroccoliCharacter = (props) => {
    const primaryColor = "#43a047"; // Bright green
    const secondaryColor = "#2e7d32"; // Darker green for stem

    const renderBroccoliBody = () => (
        <>
            {/* Broccoli Stem */}
            <mesh castShadow position={[0, -0.1, 0]}>
                <cylinderGeometry args={[0.08, 0.1, 0.4, 8]} />
                <meshStandardMaterial color={secondaryColor} />
            </mesh>

            {/* Broccoli Crown - multiple small spheres */}
            <group position={[0, 0.2, 0]}>
                {[...Array(15)].map((_, i) => {
                    // Create a random distribution of small spheres for the crown
                    const radius = 0.25;
                    const angle = Math.random() * Math.PI * 2;
                    const height = Math.random() * 0.3;
                    const distance = Math.random() * radius * 0.8;

                    const x = Math.sin(angle) * distance;
                    const z = Math.cos(angle) * distance;
                    const y = height;

                    // Randomize size slightly
                    const size = 0.08 + Math.random() * 0.04;

                    return (
                        <mesh key={i} position={[x, y, z]} castShadow>
                            <sphereGeometry args={[size, 8, 8]} />
                            <meshStandardMaterial color={primaryColor} />
                        </mesh>
                    );
                })}
            </group>
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderBroccoliBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default BroccoliCharacter;
